import './datasift_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterContent extends Monitoring.Models.SocialContents.DatasiftContent

  subType: ->
    return 'tweet'

  twitter: ->
    return @get('data').twitter

  getOriginalAuthor: ->
    if @get("data").sub_type == "retweet"
      if @get('data').retweeted_status && @get('data').retweeted_status.user
        @get('data').retweeted_status.user.screen_name #new Monitoring.Models.ContentEnhancer(@get('data').retweeted_status.user.screen_name).getContent(evidenceField: name)


  hasRoot: ->
    false

  tweet_id: ->
    return @twitter().id

  # TODO: Duplicated content with gnip/gnip_twitter_content!
  # TODO: use ContentBeautifier (see social_content#addAnchorsToLinks)
  addAnchorsToLinks: (content) ->
    content = content.replace(/(^|\s)((?:<em [^<]*?>)?@(?:<\/em>)?(?:(?:(\w*)<em [^<]*?>)?(\w+)(?:<\/em>(\w*))?))/g, '$1<a href="https://twitter.com/intent/user?screen_name=$3$4$5">$2</a>')
    return content.replace(/(<em [^<]*?>)?(https?:\/\/t.co[\w\.\-\d\/]*)(<\/em>)?([\w\.\-\d\/]*)?/g, '<a target="_blank" href="$2$4">$1$2$3$4</a>')

  location: ->
    return @twitter().user.location

  links: ->
    return @twitter().links

  retweet_count: ->
    if @twitter().retweet?
      return @twitter().retweet.count
    else
      return null

  link: -> # TODO: CAMBIAR ESTE NOMBRE!
    return "https://twitter.com/intent/user?screen_name=#{@username()}"

  contentUrl: ->
    author = @interaction().author || @interaction().user
    if author and @tweet_id()
      "https://twitter.com/#{author.username || author.id_str}/status/#{@tweet_id()}"
